'use strict';

var GridStatusController = function GridStatusController($scope) {
  $scope.statusChanged = function (newStatus) {
    if (newStatus !== $scope.data.status) {
      $scope.$emit($scope.statusEventName + ':statusChanged', $scope.data, newStatus);
    }
    $scope.$emit($scope.statusEventName + ':hide');
  };
  $scope.isStatusActive = function () {
    return $scope.data && $scope.data.status === $scope.statusActiveValue;
  };
  $scope.isStatusInactive = function () {
    return $scope.data && $scope.data.status === $scope.statusInactiveValue;
  };
};
GridStatusController.$inject = ['$scope'];
module.exports = GridStatusController;